export class TrialCabPage {
    form: HTMLFormElement;
    button: HTMLButtonElement;
    buttonContainer: HTMLElement;
    status: HTMLElement;

    constructor() {
        $(() => {
            this.initialize();
        })
    }

    initialize() {
        this.form = document.getElementById('cab-feedback-form') as HTMLFormElement;
        this.button = document.getElementById('cab-feedback-btn') as HTMLButtonElement;
        this.buttonContainer = document.getElementById('submit-button');
        this.status = document.getElementById('cab-feedback-status');

        this.form.addEventListener('submit', this.sendFeedback);
    }

    sendFeedback = async (e: Event) => {
        e.preventDefault();

        this.status.innerHTML = '';

        if (!this.validateForm()) {
            return;
        }

        this.buttonContainer.classList.add('loading');
        this.button.disabled = true;

        try {
            const formData = new FormData(this.form);

            const response = await fetch(this.form.action, {
                method: 'POST',
                body: formData,
            });

            const result = await response.json();

            if (result.success) {
                this.status.innerHTML = `<div class="alert alert-success">${result.message}</div>`;
                this.form.reset();
                return;
            }

        } catch (error) {
            this.status.innerHTML = `<div class="alert alert-danger>${error.message}</div>`;
        } finally {
            this.button.disabled = false;
            this.buttonContainer.classList.remove('loading');
        }
    }

    validateForm(): boolean {
        return ($(this.form) as any).valid();
    }
}